var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M782.89,656.99h-6.248a3.926,3.926,0,0,1-3.922-3.922v-9.989a3.927,3.927,0,0,1,3.922-3.922h6.248a3.927,3.927,0,0,1,3.922,3.922v9.989A3.927,3.927,0,0,1,782.89,656.99Zm-6.248-16.806a2.9,2.9,0,0,0-2.895,2.895v9.989a2.9,2.9,0,0,0,2.895,2.895h6.248a2.9,2.9,0,0,0,2.9-2.895v-9.989a2.9,2.9,0,0,0-2.9-2.895Z",
    transform: "translate(-772.72 -639.157)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.208 4.496)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.212 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M792.644,662.095a2.715,2.715,0,1,1,2.715-2.715A2.718,2.718,0,0,1,792.644,662.095Zm0-4.4a1.688,1.688,0,1,0,1.688,1.688A1.689,1.689,0,0,0,792.644,657.692Z",
    transform: "translate(-789.929 -656.665)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.393)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M781.831,678.563l-.044,0a.513.513,0,0,1-.468-.554c.122-1.465,1.173-4.235,4.276-4.235a.514.514,0,0,1,0,1.027c-2.928,0-3.241,3.16-3.252,3.295A.515.515,0,0,1,781.831,678.563Z",
    transform: "translate(-781.317 -673.772)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.646 4.393)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M803.685,678.564a.514.514,0,0,1-.511-.47c-.012-.138-.326-3.294-3.252-3.294a.514.514,0,0,1,0-1.027c3.1,0,4.154,2.771,4.276,4.235a.514.514,0,0,1-.469.554Z",
    transform: "translate(-799.408 -673.772)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.2ff4a10792057a7276d464b5adce320b.svg";
export { ForwardRef as ReactComponent };